const pageNameKey = "blueprintsTable";

export const blueprintsTableEn = {
  [pageNameKey]: {
    tableHeader: {
      blueprintName: "Blueprint Name",
      createDate: "Creation Date",
      updateDate: "Updated at",
      author: "Author",
      organization: "Organization",
    },
    noBlueprintsFound: "Blueprint Library is empty",
  },
};

export const blueprintsTablePtBr = {
  [pageNameKey]: {
    tableHeader: {
      blueprintName: "Nome do blueprint",
      createDate: "Data de criação",
      updateDate: "Atualizado em",
      author: "Autor",
      organization: "Organização",
    },
    noBlueprintsFound: "A Biblioteca de Blueprints está vazia",
  },
};

export const blueprintsTableDe = {
  [pageNameKey]: {
    tableHeader: {
      blueprintName: "Blueprint Name",
      createDate: "Erstellungsdatum",
      updateDate: "Aktualisiertungsdatum",
      author: "Author",
      organization: "Organisation",
    },
    noBlueprintsFound: "Blueprint Library is leer",
  },
};

export const blueprintsTableZhHans = {
  [pageNameKey]: {
    tableHeader: {
      blueprintName: "蓝图名称",
      createDate: "创建日期",
      updateDate: "更新日期",
      author: "作者",
      organization: "组织",
    },
    noBlueprintsFound: "蓝图库为空",
  },
};

export const blueprintsTableIt = {
  [pageNameKey]: {
    tableHeader: {
      blueprintName: "Nome del Blueprint",
      createDate: "Data di creazione",
      updateDate: "Aggiornato a",
      author: "Autore",
      organization: "Organizzazione",
    },
    noBlueprintsFound: "La libreria dei Blueprint è vuota",
  },
};

export const blueprintsTableEs = {
  [pageNameKey]: {
    tableHeader: {
      blueprintName: "Nombre del plano",
      createDate: "Fecha de creación",
      updateDate: "Actualizado a las",
      author: "Autor",
      organization: "Organización",
    },
    noBlueprintsFound: "La biblioteca de planos está vacía",
  },
};

export const blueprintsTableNl = {
  [pageNameKey]: {
    noBlueprintsFound: "Blueprint-bibliotheek is leeg",
    tableHeader: {
      blueprintName: "Blueprint-naam",
      createDate: "Aanmaak op ",
      updateDate: "Bijgewerkt op",
      author: "Auteur",
      organization: "Organisatie",
    },
  },
};

export const blueprintsTableTr = {
  [pageNameKey]: {
    tableHeader: {
      author: "Yazar",
      blueprintName: "Plan Adı",
      createDate: "Oluşturulma Tarihi",
      organization: "Organizasyon",
      updateDate: "Güncelleme tarihi:",
    },
    noBlueprintsFound: "Blueprint Kitaplığı boş",
  },
};
